<template>
    <div class="wrap">
        <div class="content">
            <base-header :name="user_name" :topOnly="flag_top" :account_list="account_list"></base-header>
            <div class="name">{{ user_name || '' }}</div>
            <div class="jd">当前账号酒豆余额：<span>{{ money2 }}</span></div>
        </div>
    </div>
</template>
<script>
import { baseUrls } from "@/utils/baseUrlConfig";
const base_url = baseUrls.user_url;

export default {
    name: "luckyPlayer",
    data() {
        return {
            token: this.$storage.getToken(),
            user_name: "",
            flag_top: true,
            account_list: [],
            btn_lock: false, //防抖
            timer: null, //提示框定时器
            money2: 0,
        };
    },
    mounted() {
        this.requireToken();
    },
    // beforeRouteEnter(to, from, next) {
    //     next((vm) => {
    //         if (vm.$common.checkToken(vm.token)) {
    //             vm.$http.set_anchor(15, vm.token);
    //         }
    //     });
    // },
    methods: {
        requireToken() {
            var Ucookie = this.token;
            if (Ucookie != null) {
                var now = new Date().getTime();
                if (now >= Ucookie.split("-")[3] * 1000) {
                    //token过期
                    this.get_auth();
                } else {
                    this.init();
                }
            } else {
                this.get_auth();
            }
        },
        init() {
            this.token = this.$storage.getToken()
            this.query_user_baseInfo();
            // this.getUserInfo();
            this.getMoney()
        },
        // 获取用户基础信息（是否为plus，以及plus的剩余天数）
        query_user_baseInfo() {
            $.ajax({
                url: "https://users.09game.com/home/GetUserPub?user_id=" + this.token.split("-")[0],
                async: false,
                success: (res) => {
                    if (res.result == 0) {
                        var u = res.temp[0];
                        this.user_name = u.user_name;
                        this.$storage.setUserId(u.user_id);
                        this.$storage.setUserName(u.user_name);
                    } else {
                        console.log("获取用户信息错误，错误码：" + res.result);
                    }
                },
            });
            this.$http.getAllUser(this.token).then((res) => {
                if (res.result == 0 && res.msg && res.msg.length > 0) {
                    this.account_list = res.msg;
                    this.$storage.setAccountList(JSON.stringify(res.msg));
                } else {
                    this.account_list = [];
                }
            });
        },
        // getUserInfo() {
        //     let _this = this;
        //     $.ajax({
        //         url: 'https://users.09game.com/Home/GetUserInfoV1?token=' + token,
        //         success: function (res) {
        //             if (res.result == 0 && res.temp) {
        //                 _this.name = res.temp.name;
        //             }
        //         }
        //     })
        // },
        getMoney() {
            query_shop('q_my_money', { token: this.token }, (res) => {
                if (res.code == 0) {
                    this.money2 = res.records[0].money2;
                }
            })
        },
        get_auth() {
            window.location.replace(base_url + "/GetWxOpenid?fromPage=luckyPlayer");
        },
    },
};
function query_shop(type, json, cb, flag = true) {
    let post = JSON.stringify({
        type: type,
        json: JSON.stringify(json)
    });
    $.ajax({
        url: `https://shop.09game.com/shop?${post}`,
        async: flag,
        success(res) {
            cb(res);
        }
    })
}
</script>

<style lang="scss" scoped>
html {
    width: 100wh;
    height: 100vh;

    .wrap {
        width: 100wh;
        height: 100vh;
        position: relative;
        background-color: #190703;

        .content {
            position: absolute;
            width: 7.5rem;
            height: 14.48rem;
            top: 0;
            left: 0;
            background: url(~@/assets/img/luckyPlayer/luckyBg.jpg) 0 0 no-repeat;
            background-size: cover;
            box-sizing: border-box;

            .name {
                position: absolute;
                top: 4.05rem;
                left: 2.8rem;
                width: 1.9rem;
                font-size: 0.28rem;
                text-align: center;
                color: #FFCF5D;
                font-weight: bold;
            }

            .jd {
                position: absolute;
                top: 10.32rem;
                left: 1.55rem;
                width: 4.35rem;
                font-size: 0.28rem;
                text-align: center;
                color: #FFF0CC;
                font-weight: bold;

                span {
                    color: #FFCF5D;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/luckyPlayer.vue